<template>
    <div class="modal fade" id="modal_member_assurance_payment" tabindex="-1" data-bs-backdrop='static'
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestMemberAssurance" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.income.payment.title') }}

                    </h5>
                    <button @click="closeModal('modal_member_assurance_payment', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPayment">
                    <!-- information member (rocette) -->
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="row">
                                <div v-if="member?.name" class="col-md-12 mb-2">
                                    <p class="timeline-content">
                                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.name") }} </b>: {{
                                            member?.name }}
                                    </p>
                                </div>
                                <div v-if="hasPermission('download_contract') && member?.contractNumber"
                                    class="col-md-12 mb-2">
                                    <p class="timeline-content">
                                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.contractNumber")
                                        }}
                                        </b>
                                        :<span class="actif">
                                            {{ member?.contractNumber }}
                                        </span>
                                    </p>
                                </div>
                                <div v-if="member?.matricule" class="col-md-12 mb-2">
                                    <p class="timeline-content">
                                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.matricule") }}
                                        </b>:
                                        <span class="actif">
                                            {{ member?.matricule }}
                                        </span>
                                    </p>
                                </div>


                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div v-if="member?.cin" class="col-md-12 mb-2">
                                    <p class="timeline-content">
                                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.cin") }}
                                        </b>
                                        :<span class="actif">
                                            {{ member?.cin }}
                                        </span>
                                    </p>
                                </div>
                                <div v-if="member?.tele" class="col-md-12 mb-2">
                                    <p class="timeline-content">
                                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.tele") }}
                                        </b>
                                        :<span class="actif">
                                            {{ member?.tele }}
                                        </span>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <hr>
                    <!-- end information member (rocette) -->
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <form class="forms-sample" @submit.prevent="submitForm">




                                <div class="row">
                                    <div class="col-md-12">
                                        <SingleSelect :TextLabel="i18n.t('tables.subscription_member.assurance')"
                                            :trackby="`id`" :label="`type`" :valueProp="`id`"
                                            v-model="requestPayment.assurance_id"
                                            :placeholder="i18n.t('tables.subscription_member.assurance')"
                                            :arrayOptions="assurancesList" refs="assurance_id" :v="v$.assurance_id" />
                                    </div>
                                    <div v-if="selectedAssurance" class="col-md-12 mb-2 mt-2">
                                        <p class="form__label  ">
                                            <b> {{ i18n.t('tables.member_assurances.assurance') }} : </b>
                                            <span>
                                                {{ selectedAssurance?.type }} {{
                                                    formatDaysToPeriod(selectedAssurance?.nbDays) }}
                                            </span>

                                        </p>
                                        <p class="form__label  ">
                                            <b> {{ i18n.t('tables.member_assurances.total_amount') }} : </b>
                                            <span>
                                                {{ selectedAssurance?.cost }} {{ i18n.t('symbole.currency.mad') }}
                                            </span>

                                        </p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row mt-3 ">




                                    <div class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <date-field v-model="requestPayment.payment.paymentDate"
                                                :label="i18n.t('tables.payment.paymentDate')"
                                                :v="v$.payment.paymentDate" :disabled="false" :fixedDays="1"
                                                :isFixedDays="true" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')"
                                            :trackby="`id`" :label="`name`" :valueProp="`id`"
                                            v-model="requestPayment.payment.paymentMethod"
                                            :placeholder="i18n.t('tables.payment.paymentMethod')"
                                            :arrayOptions="payment_methodsList" refs="paymentMethod"
                                            :v="v$.payment.paymentMethod" />
                                    </div>
                                    <div v-if="requestPayment.payment.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                            :label="`name`" :valueProp="`id`" v-model="requestPayment.payment.bankName"
                                            :placeholder="i18n.t('tables.payment.bankName')"
                                            :arrayOptions="bank_namesList" refs="bankName" :v="v$.payment.bankName" />
                                    </div>

                                    <div v-if="requestPayment.payment.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <inputText v-model="requestPayment.payment.chequeName"
                                                :label="i18n.t('tables.payment.chequeName')" :v="v$.payment.chequeName"
                                                :disabled="false" />
                                        </div>
                                    </div>
                                    <div v-if="requestPayment.payment.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <inputText v-model="requestPayment.payment.chequeNum"
                                                :label="i18n.t('tables.payment.chequeNum')" :v="v$.payment.chequeNum"
                                                :disabled="false" />
                                        </div>
                                    </div>

                                    <div v-if="requestPayment.payment.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <date-field v-model="requestPayment.payment.dueDate"
                                                :label="i18n.t('tables.payment.dueDate')" :v="v$.payment.dueDate"
                                                :disabled="false" :fixedDays="1" :isFixedDays="false" />
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <price-input v-model="requestPayment.payment.amount_paid"
                                                :label="i18n.t('tables.payment.amount_paid')"
                                                :v="v$.payment.amount_paid" :disabled="false" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-right">
                                    <button type="submit" class="btn btn-primary mr-2">
                                        {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                                    </button>
                                    <button type="button" @click="emptyState()" class="btn btn-cancel">
                                        {{ i18n.t('button.cancel') }}
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, toRefs, Ref } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";



/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, helpers, requiredIf } from "@vuelidate/validators";

import i18n from "@/i18n/index"
import dayjs from 'dayjs';

/*composables & states */
import { usePermission } from "@/composables/auth/usePermission";
import { useModal } from '@/composables/modal/useModal';
import { usePayment } from "@/composables/payment/usePayment";
import { useMemberAssurance } from "@/composables/member/useMemberAssurance";
import { clubUUID, bank_names, payment_methods, assurances } from "@/shared/state";

import { MemberAssuranceRequest } from "@/interfaces/assurance";
import { useGlobal } from "@/composables/global/useGlobal";

export default defineComponent({
    components: { inputText, SingleSelect },
    name: "SomeComponent",
    emits: ['savedAssurance'],
    props: {
        member: {
            type: Object,
            default: null,
        },
        // editFrom: {
        //     type: String,
        //     default: null,
        // }
    },
    setup(props, { emit }) {
        const { member } = toRefs(props);

        const action = ref('add')
        const { formatDate, formatDaysToPeriod } = useGlobal();
        const { hasPermission } = usePermission();
        const requestPayment = ref<MemberAssuranceRequest>({
            assurance_id: null,
            clubUUID: clubUUID?.value,
            memberUUID: member?.value?.uuid,
            cost: null,
            payment: {
                amount_paid: null,
                paymentMethod: null,
                bankName: null,
                chequeName: null,
                chequeNum: null,
                dueDate: null,
                paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
                status: "paid",
                reference_id: null,
                reference_type: "assurances"

            }
        });

        const assurancesList = computed(() => assurances.data);
        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const { closeModal } = useModal();

        const { regulationMemberAssurance, isRequestMemberAssurance } = useMemberAssurance();


        // Validation 
        const rules = {
            assurance_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            memberUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            payment: {
                reference_type: {
                    required: helpers.withMessage(i18n.t("validation.required"), required)
                },
                paymentMethod: {
                    required: helpers.withMessage(i18n.t("validation.required"), required)
                },
                paymentDate: {
                    required: helpers.withMessage(i18n.t("validation.required"), required)
                },
                bankName: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPayment?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                chequeName: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPayment?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                chequeNum: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPayment?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                dueDate: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPayment?.value?.payment?.paymentMethod === 'Chèque bancaire')),
                },

                amount_paid: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPayment?.value?.payment?.paymentMethod !== null)),
                    numeric,
                    paidAmountValid: helpers.withMessage(
                        i18n.t("validation.amountExceededError"),
                        (value) => {
                            const numberValue = Number(value);
                            const total_amount = totalAmount.value || 0
                            return numberValue !== null && numberValue <= total_amount;
                        }
                    )
                }
            }

        };
        const v$ = useVuelidate(rules, requestPayment as Ref<Required<MemberAssuranceRequest>>, { $scope: 'payment-icome' });


        const selectedAssurance = computed(() => assurancesList.value?.find((s) => s?.id == requestPayment.value?.assurance_id))

        /**
         * Add or edit Service
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    requestPayment.value.clubUUID = clubUUID?.value
                    requestPayment.value.memberUUID = member?.value?.uuid
                    await regulationMemberAssurance(requestPayment.value); 
                    emit('savedAssurance')

                }
            }
        }


        watch(
            () => member.value,
            (newValue) => {

                emptyState()

            });

        const emptyState = () => {
            action.value = 'add';
            requestPayment.value.clubUUID = clubUUID?.value
            requestPayment.value.memberUUID = member?.value?.uuid
            requestPayment.value.assurance_id = null
            requestPayment.value.cost = null

            requestPayment.value.payment.chequeName = null
            requestPayment.value.payment.chequeNum = null
            requestPayment.value.payment.amount_paid = null
            requestPayment.value.payment.dueDate = null
            requestPayment.value.payment.paymentMethod = null
            requestPayment.value.payment.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            v$.value.$reset();
            closeModal('modal_member_assurance_payment', 'add')
        };





        const totalAmount = computed(
            () => {
                return selectedAssurance?.value?.cost;
            }
        )




        return {
            selectedAssurance,
            assurancesList,
            hasPermission,
            requestPayment,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,
            bank_namesList,
            payment_methodsList,
            closeModal,
            isRequestMemberAssurance,
            formatDate,
            formatDaysToPeriod
        };
    },
});
</script>
